@if(currentURL=='profile' || currentURL1=='inbox' || currentURL=='add-experiences' || currentURL =='news-feeds' || currentURL == 'list-influencers' ||
currentURL =='our-friends' || currentURL =='refer-friends' || currentURL =='find-vebo-couples' || currentURL=='gift-tracker' || 
currentURL=='settings' || currentURL1=='add-experience-by-city' || currentURL1=='add-experiences' || currentURL == 'region' || currentURL1 == 'vebo-seats'){
    <div class="wedding-couple-subheader" id="wedding-couple-subheader">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <!-- <div class="wedding-couple-menu-toggle d-lg-none" id="wedding-couple-menu-toggle">
                    Menu
                    <i class="fas fa-long-arrow-down"></i>
                    </div> -->
                <div class="navbar-collapse" id="weddingCoupleNav" hidden>
                    <ul class="navbar-nav ">
                        <li class="nav-item">
                            @if(authCheck && authUser?.role_id == '1' && currentURL == 'region'){
                                <a class="nav-link" 
                                    routerLink="/add-experience-by-city" 
                                    [queryParams]="{'location': location_id}">
                                        RETURN TO STATE
                                </a>
                            }
                        </li>
                    </ul>
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/profile']">Our Registry</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'add-experiences' || currentURL == 'add-experience-by-city' || currentURL == 'region' || currentURL1=='add-experience-by-city' || currentURL1=='add-experiences')}">
                            <a class="nav-link" [routerLink]="['/add-experiences']">Add EXPERIENCES</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/gift-tracker']">Gift tracker</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'news-feeds' || currentURL == 'our-friends' || currentURL == 'refer-friends'  || currentURL == 'find-vebo-couples')}">
                            <a class="nav-link" [routerLink]='"/our-friends"'>Connect
                                <!-- @if(total_notification_counter>0){
                                    <span class="blue_menu_notification_counter">
                                        {{total_notification_counter}}
                                    </span>
                                } -->
                                <div class="friend_counter">
                                    <img src="assets/images/icon-friend.png">
                                    @if(total_friend_counter>0){
                                        <span class="red_menu_friend_notification_counter">
                                            {{total_friend_counter}}
                                        </span>
                                    }
                                </div>
                            </a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/inbox']">Inbox</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL1 == 'vebo-seats')}">
                            <a class="nav-link" [routerLink]="['/ticket-category']">SPURTicketing</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/settings']">Settings</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>

        <!-- <div class="custom_new_teag" *ngIf="currentURL=='profile'">
        E-WALLET TOTAL:
        <br>
        <strong>${{wallet_balance}}</strong>
        </div> -->

        <!-- <div class="new_cart_pop_div" *ngIf="authCheck && is_cart_fill">
        <div class="new_cart_popup_button_div">
        <a href="javascript:void(0);" class="cart_popup_open_button"  (click)="getCartDetail()">
            <span class="cart-icon"></span>
            <span class="cart_count_popup">{{cart_details.length}}</span>
        </a>
        </div>
        </div> -->

    </div>
}
@if(currentURL=='ticket-category' || currentURL=='ticket-evolution-category' || currentURL=='our-tickets'){
    <div>
        <!-- <app-veboticketing-subheader></app-veboticketing-subheader> -->
        <app-veboticketing-subheader></app-veboticketing-subheader>
    </div>
}

@if(authUser.status=='2' && (currentURL=='profile' || currentURL=='add-experiences' || currentURL=='ticket-category' || currentURL =='news-feeds' || currentURL=='gift-tracker' || currentURL=='settings' || currentURL1=='add-experience-by-city' || currentURL1=='add-experiences')){
    <div style="background-color: #981f41;color: white;padding: 5px;text-align: center;">
        Account Inactive – You have deactivated your account and it is no longer active. To reactivate, please visit DEACTIVATE ACCOUNT.
    </div>
}

@if(show_card_details){
    <div class="cartpopup-wrap">
        <div class="cartpopup-overly"></div>
        <div class="cartpopup_box">
            <div class="cartpopup_head">
                <span class="cart_counter">
                    <span class="cart-icon"></span>
                    <span class="cart_count_popup">{{cart_details.length}}</span>
                </span>
                <span class="odr-title">YOUR ORDER</span>
                <a href="javascript:void(0);" class="cart_pop_close" (click)="show_card_details = !show_card_details">
                    <i class="fa fa-times remove"></i>
                </a>
            </div>

            <div class="cartpopup_content">
                <!-- Empty Box START -->
                @if(cart_details && cart_details.length == 0){
                    <div class="cartpopup_empty">
                        <p>Your cart is currently empty.</p>
                        <a href="javascript:void(0);" class="btn" (click)="show_card_details = !show_card_details">← Return To Shop</a>
                    </div>
                }
                <!-- Empty Box END -->
                @if(cart_details && cart_details.length > 0){
                    <div class="cartpopup_content_inner">
                        @for(cart of cart_details;track cart){
                            <div class="cartpopup_product">
                                <div class="cartpopup_removecart">
                                    <a href="javascript:void(0);" title="Remove this item" (click)="removeItem(cart.product_id)">×</a>
                                </div>
                                <div class="cartpopup_proname">
                                    <a href="javascript:void(0)">{{cart.title}}</a>
                                </div>
                                <!-- <div class="cartpopup_vrcname">
                                        <span>Name on Voucher:</span>
                                        ashu23223 sdf estef tets sefdsf
                                    </div> -->
                                <div class="cartpopup_proqty">
                                    Quantity: {{cart.qty}}
                                </div>
                                <div class="cartpopup_vrcname">
                                    <span>Option:</span> {{cart.type}}
                                </div>
                                <div class="row no-gutters mt-2 align-items-end">
                                    <div class="col">
                                        <div class="cartpopup_wall">
                                            <img class="lazyload" src="../../../assets/images/loading.gif" [attr.data-src]="(cart.image == '') ? '../../../assets/images/vebo_find_img.png' : expUplodsUrl+cart.image" alt="{{cart.title}}" />
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="cartpopup_proprice">
                                            ${{cart.line_total}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <!-- <div class="cartpopup_product">
                        <div class="cartpopup_removecart">
                            <a href="javascript:void(0);" title="Remove this item">×</a>
                        </div>
                        <div class="cartpopup_proname">
                            <a href="javascript:void(0)">Group Fly Fishing</a>
                        </div>
                        <div class="cartpopup_vrcname">
                            <span>Name on Voucher:</span>
                            ashu23223 sdf estef tets sefdsf
                        </div>
                        <div class="cartpopup_proqty">
                            Quantity: 1
                        </div>
                        <div class="cartpopup_vrcname">
                            <span>Option:</span>
                            Buy For Yourself
                        </div>
                        <div class="row no-gutters mt-2 align-items-end">
                            <div class="col">
                            <div class="cartpopup_wall">
                                <img src="assets/images/home_owl_1.jpg" alt="" />
                            </div>
                            </div>
                            <div class="col">
                            <div class="cartpopup_proprice">
                                $525
                            </div>
                            </div>
                        </div>
                        </div> -->
                    </div>
                }
                @if(cart_details && cart_details.length > 0){
                    <div class="cartpopup_content_footer">
                        <div class="cartpopup_total">
                            <div class="form-row">
                                <div class="col">
                                    <strong>Sales Tax</strong>
                                </div>
                                <div class="col">
                                    <div class="cartpopup-amount">${{total_sales_tax}}</div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col">
                                    <strong>Total: </strong>
                                </div>
                                <div class="col">
                                    <div class="cartpopup-amount">${{total_cart_amount}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="cartpopup_continueshop_btn">
                            <a href="javascript:void(0)" (click)="show_card_details = !show_card_details">Continue Shopping</a>
                        </div>
                        <div class="cartpopup_checkout_btn">
                            <a href="javascript:void(0)" (click)="checkout()">CHECKOUT</a>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}

<!-- <div class="totalitem_tag_wrap" id="totaltag_clicked">
	
  <div class="totalitem_tag" id="totaltag_click">
    1 item
  </div>
  <div class="totalitem_tag_data">
    <h3> 1 ITEM TO COMPLETE!</h3>
    <a href="javascript:void(0)">ADD WEDDING DATE</a>
  </div>
</div> -->


<!-- Full Modal Popup START -->

<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
  Launch demo modal
</button> -->

<!-- Modal -->
<div class="modal fade fullmodal" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <i class="fa fa-times"></i>
      </button>
            <div class="modal-body">
                <section>
                    <div class="container-fluid ">
                        <div class="row registeryParent parentLoading lazyload" data-bg="https://picsum.photos/1980/600?random=1" style="background-image:url('assets/images/largeloading.gif')">
                            <div class="col-12 px-0 h-100">
                                <h2 class="comName">COLORADO_EXP2
                                    <!-- <p class="webName"><span>http://anim.com</span></p> -->
                                </h2>

                                <div class="profileImg">
                                    <figure class="lazyload" style="background-image:url('assets/images/loading.gif')" data-bg="https://picsum.photos/180/180?random=1">
                                        <img class="lazyload" data-src="https://picsum.photos/180/100?random=1" src="assets/images/loading.gif" alt="" />
                                    </figure>
                                </div>

                            </div>


                        </div>
                    </div>

                    <!-- Return to search btn  -->



                    <div class="productReview">
                        <div class="container">
                            <h3 class="productInfo_head">Colorado_Exp2</h3>
                            <div class="modalPlay_btn">
                                <button class="btn"><i class="fas fa-video"></i> Experience Preview </button>
                            </div>
                            <div class="productInfo">
                                <div class="form-row">
                                    <div class="col-4">
                                        <div class="productInfo_owl">
                                            <owl-carousel [options]="owlCharityDetail">
                                                <div class="item ">
                                                    <img class="lazyload" data-src="https://picsum.photos/373?random=1" alt="" src="assets/images/loading.gif">
                                                </div>
                                                <div class="item">
                                                    <img class="lazyload" data-src="https://picsum.photos/373?random=2" alt="" src="assets/images/loading.gif">
                                                </div>
                                                <div class="item">
                                                    <img class="lazyload" data-src="https://picsum.photos/373?random=3" alt="" src="assets/images/loading.gif">
                                                </div>
                                            </owl-carousel>
                                            <h4 class="received_viewCount redeemed">REDEEMED</h4>
                                            <h4 class="received_viewCount exchanged" style="display: none;">EXCHANGED</h4>
                                            <h4 class="received_viewCount received" style="display: none;">RECEIVED</h4>
                                        </div>

                                    </div>
                                    <div class="col-8">
                                        <div class="add-experiences_modalright">
                                            <div class="productDes">
                                                <h5><a href="javascript:void(0)">EP_FOR_TESTING.</a> <span> TSET, TSET</span></h5>
                                            </div>
                                            <div class="addCouplePrice">
                                                <p>It is a long established fact that a reader will be distracted by the readable content of a page </p>
                                                <div class="couple_priceList">$1.00 <span>&#123; Per Couple &#125;</span></div>

                                                <div class="partiallyprice_box">
                                                    <h4><strong>PARTIALLY FUNDED : <span>$799.00</span> RECEIVED</strong></h4>
                                                    <h5>(AMOUNT REMAINING : <strong>$719.10</strong>)</h5>
                                                </div>
                                            </div>

                                            <div class=pendingapp_box>
                                                <p>Ashu23223 sdf and Tets your request to book has been sent. You will receive an email response in 48 hours.</p>
                                                <div class="pendingapp_box_innr">
                                                    <h5>REQUEST TO BOOK JUNE 21, 2018</h5>
                                                    <h3>PENDING APPROVAL</h3>
                                                </div>
                                            </div>

                                            <!-- Review Block START -->
                                            <div class="modal_review_block">
                                                <div class="bv_stars_component_container">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <span class="bv_stars_counter">5 (1)</span>
                                                    <a href="javascript:void(0)" class="modal_writereview">Write a review</a>
                                                </div>
                                            </div>
                                            <!-- Review Block END -->

                                            <div class="buyadd_btns">

                                                <div>
                                                    <button class="btn btnreview_submt"> review submitted</button>
                                                </div>
                                                <div>
                                                    <button class="btn btnadd"> Add to registry </button>
                                                </div>

                                                <div>
                                                    <button class="btn btnadd"> remove from registry </button>
                                                </div>

                                                <div>
                                                    <button class="btn btnadd"> Add photo/video </button>
                                                </div>

                                                <!-- <div>
                                                    <button class="btn btnadd_join"> Add With Join Us </button>
                                                </div> -->

                                                <div>
                                                    <button class="btn btnadd_join"> Close </button>
                                                </div>

                                                <div>
                                                    <button class="btn btnadd_join"> Complete purchase </button>
                                                </div>

                                                <div>
                                                    <button class="btn btnadd_join"> exchange </button>
                                                </div>

                                                <div>
                                                    <button class="btn btnadd_join"> GO TO SPUR TICKETING </button>
                                                </div>

                                                <div>
                                                    <button class="btn btnbuy"> Buy For yourself </button>
                                                </div>

                                            </div>

                                            <div class="buyas_giftbtn">
                                                <a href="javascript:void(0)">BUY AS A GIFT</a>
                                            </div>

                                            <div class="modalEwallet_total">
                                                E-WALLET TOTAL: <strong> $968.00</strong>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="productTabInfo">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" id="summary-tab" data-toggle="tab" href="#summary" role="tab" aria-controls="home" aria-selected="true">SUMMARY</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="detail-tab" data-toggle="tab" href="#detail" role="tab" aria-controls="profile" aria-selected="false">DETAILS</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="review-tab" data-toggle="tab" href="#review" role="tab" aria-controls="contact" aria-selected="false">REVIEWS</a>
                                        </li>
                                    </ul>
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="summary" role="tabpanel" aria-labelledby="summary-tab">
                                            <div class="summaryDetailTab">
                                                <div class="container">
                                                    <div class="row">
                                                        <div class="col-12 px-0">
                                                            <div class="headingParent">
                                                                <!-- <h2>THE EXPERIENCE</h2> -->
                                                                <p>It is a long established fact that a reader will be distracted by the readable content.
                                                                </p>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="detail" role="tabpanel" aria-labelledby="detail-tab">
                                            <div class="summaryDetailTab">
                                                <div class="container">
                                                    <div class="row">
                                                        <div class="col-12 px-0">
                                                            <div class="headingParent">
                                                                <!-- <h2>THE EXPERIENCE</h2> -->
                                                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
                                                                    distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum
                                                                    as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes
                                                                    on purpose (injected humour and the like).</p>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="review" role="tabpanel" aria-labelledby="review-tab">
                                            <div class="summaryDetailTab">
                                                <div class="container">
                                                    <div class="row">
                                                        <div class="col-12 px-0">
                                                            <div class="headingParent">
                                                                <!-- <h2>THE EXPERIENCE</h2> -->
                                                                <p>test <br>est, test 124</p>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>
    </div>
</div>
